import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cardExpiryPlaceholder: 'Expiry Date',
    cardNumberPlaceholder: 'Card Number',
    cvcPlaceholder: 'CVV',
  },
  fr: {
    cardExpiryPlaceholder: 'Date d’expiration',
    cardNumberPlaceholder: 'Numéro de carte',
    cvcPlaceholder: 'CVV',
  },
});

export default locales;
